/* TEALBEE CUSTOM: sleep sack finder (sections/tealbee-quiz.liquid) — see CUSTOMIZATIONS.md */
(function () {
  'use strict';

  /* Height → sizes. "sack" lists the sleep sack sizes that fit, the suggested
     one first (we size up where two fit). Pajamas fit up to 38 in. */
  var HEIGHTS = {
    h1: { label: 'Under 31 in', sack: ['12m-2t'], pj: '12-18m' },
    h2: { label: '31–33 in', sack: ['12m-2t'], pj: '18-24m' },
    h3: { label: '33–35 in', sack: ['2t-3t', '12m-2t'], pj: '2t-3t' },
    h4: { label: '35–38 in', sack: ['3t-4t', '2t-3t'], pj: '3t-4t' },
    h5: { label: 'Over 38 in', sack: ['3t-4t'], pj: '' }
  };
  var SIZE_LABELS = { '12m-2t': '12m–2T', '2t-3t': '2T–3T', '3t-4t': '3T–4T' };
  var SIZE_ORDER = ['12m-2t', '2t-3t', '3t-4t'];

  /* Room → TOG, from the sleep sack TOG guide, split so the bands don't overlap. */
  var ROOMS = {
    warm: { tog: '0.8', label: 'Over 72°F' },
    typical: { tog: '1.2', label: '68–72°F' },
    cool: { tog: '1.5', label: 'Under 68°F' },
    unsure: { tog: '1.2', label: 'Room temp not sure' }
  };
  var TOGS = {
    '0.8': { note: 'warm rooms', cls: 'tbq-tog--08' },
    '1.2': { note: 'all season', cls: 'tbq-tog--12' },
    '1.5': { note: 'cool rooms', cls: 'tbq-tog--15' }
  };
  var STYLES = {
    dreamsuit: { name: 'Dreamsuit', plural: 'Dreamsuits', chip: 'Feet out, legs to walk' },
    dreamsie: { name: 'Dreamsie', plural: 'Dreamsies', chip: 'Convertible feet' },
    dreambag: { name: 'Dreambag', plural: 'Dreambags', chip: 'Classic sack, under 2T' }
  };
  var SOURCE = 'Sleep sack finder';

  var ICON_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var ICON_DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/></svg>';
  var ICON_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>';

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function hl(text) { return '<span class="highlight hl-font">' + esc(text) + '</span>'; }
  function sizeLabel(size, fallback) { return SIZE_LABELS[size] || String(fallback || size || '').replace(/-/g, '–'); }
  function find(list, fn) { for (var i = 0; i < list.length; i++) { if (fn(list[i])) return list[i]; } return null; }
  function byId(list, id) { return id ? find(list, function (p) { return p.id === id; }) : null; }
  function baseUrl(root) { return String(root || '/').replace(/\/?$/, '/'); }
  function withVariant(url, id) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id; }

  /* Shop money format, e.g. "${{amount}}". */
  function money(cents, format) {
    var amount = cents / 100;
    return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return Math.round(amount).toLocaleString('en-US');
      if (key === 'amount_with_comma_separator') return amount.toFixed(2).replace('.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return String(Math.round(amount));
      return amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  function availVariant(p, size) {
    return find(p.variants, function (v) { return v.available && (!size || v.size === size); });
  }

  function sessionId() {
    var key = 'tbq-sid', id = '';
    try { id = sessionStorage.getItem(key) || ''; } catch (e) {}
    if (!id) {
      id = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      try { sessionStorage.setItem(key, id); } catch (e) {}
    }
    return id;
  }

  function Quiz(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-tbq-data]').textContent);
    this.recs = {};
    this.sid = sessionId();
    this.reset();
    this.bind();
    try { history.replaceState(Object.assign({}, history.state, { tbqStep: 'style' }), ''); } catch (e) {}
    this.track('view');
  }

  Quiz.prototype.reset = function () {
    this.state = { style: '', room: '', height: '', sackSize: '', heroId: 0, pjId: 0, pjUser: false, pjOpen: false, started: this.state ? this.state.started : false };
    this.current = null;
    this.root.querySelectorAll('[data-tbq-pick]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
  };

  Quiz.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tbq-pick],[data-tbq-back],[data-tbq-restart],[data-tbq-to-dreamsuit],[data-tbq-size],[data-tbq-swap],[data-tbq-pj-toggle],[data-tbq-pj],[data-tbq-add],[data-tbq-offer-link],[data-tbq-vote],[data-tbq-vote-send]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-tbq-pick')) self.pick(t.getAttribute('data-tbq-pick'), t.getAttribute('data-value'), t);
      else if (t.hasAttribute('data-tbq-to-dreamsuit')) {
        var suit = root.querySelector('[data-tbq-pick="style"][data-value="dreamsuit"]');
        if (suit) self.pick('style', 'dreamsuit', suit);
      }
      else if (t.hasAttribute('data-tbq-back')) history.back();
      else if (t.hasAttribute('data-tbq-restart')) self.restart();
      else if (t.hasAttribute('data-tbq-size')) self.update({ sackSize: t.getAttribute('data-tbq-size') }, 'size');
      else if (t.hasAttribute('data-tbq-swap')) self.update({ heroId: +t.getAttribute('data-tbq-swap'), pjUser: false, pjOpen: false }, 'swap', true);
      else if (t.hasAttribute('data-tbq-pj-toggle')) self.update({ pjOpen: !self.state.pjOpen });
      else if (t.hasAttribute('data-tbq-pj')) self.update({ pjId: +t.getAttribute('data-tbq-pj'), pjUser: true, pjOpen: false }, 'pajama_print');
      else if (t.hasAttribute('data-tbq-add')) self.add(t.getAttribute('data-tbq-add'), t);
      else if (t.hasAttribute('data-tbq-offer-link')) {
        e.preventDefault();
        var offer = document.getElementById(self.data.offerId);
        if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      else if (t.hasAttribute('data-tbq-vote')) t.setAttribute('aria-pressed', t.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      else if (t.hasAttribute('data-tbq-vote-send')) self.sendVotes();
    });

    window.addEventListener('popstate', function (e) {
      var step = e.state && e.state.tbqStep;
      if (!step) return;
      if (step === 'result' && !self.state.height) step = 'style';
      self.show(step, false);
    });

    /* Show the 10% panel only once Klaviyo has drawn the form into it. */
    var kl = root.querySelector('[data-tbq-klaviyo]');
    if (kl) {
      var ready = function () {
        if (!kl.children.length) return false;
        root.classList.add('tbq--offer');
        return true;
      };
      if (!ready()) {
        var watch = new MutationObserver(function () { if (ready()) watch.disconnect(); });
        watch.observe(kl, { childList: true, subtree: true });
      }
    }

    if (this.data.formId) {
      window.addEventListener('klaviyoForms', function (e) {
        var d = e.detail || {};
        if (String(d.formId) !== self.data.formId) return;
        if (d.type === 'embedOpen') root.classList.add('tbq--offer');
        if (d.type !== 'submit') return;
        self.emailed = true;
        self.track('email');
        self.identify(self.setProps());
        var more = root.querySelector('[data-tbq-more]');
        if (more) more.open = true;
      });
    }
  };

  Quiz.prototype.pick = function (kind, value, btn) {
    var st = this.state, next;
    btn.parentNode.querySelectorAll('[data-tbq-pick]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    if (kind === 'style') {
      if (!st.started) { st.started = true; this.track('start'); }
      st.style = value;
      if (value === 'dreambag') st.room = '';
      this.track('style');
      next = value === 'dreambag' ? 'height' : 'room';
    } else if (kind === 'room') {
      st.room = value;
      this.track('room');
      next = 'height';
    } else {
      st.height = value;
      st.sackSize = '';
      st.heroId = 0;
      st.pjId = 0;
      st.pjUser = false;
      st.pjOpen = false;
      this.track('height');
      this.renderResult();
      this.track('result');
      next = 'result';
    }
    this.show(next, true);
  };

  Quiz.prototype.restart = function () {
    this.track('restart');
    this.reset();
    this.show('style', true);
  };

  Quiz.prototype.show = function (step, push) {
    var self = this;
    this.root.querySelectorAll('[data-tbq-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-tbq-step') !== step;
    });
    this.root.setAttribute('data-tbq-at', step);
    this.progress();
    if (push) {
      try { history.pushState(Object.assign({}, history.state, { tbqStep: step }), ''); } catch (e) {}
    }
    var top = this.root.getBoundingClientRect().top + window.pageYOffset - 80;
    if (window.pageYOffset > top) window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    setTimeout(function () { self.focusHeading(); }, 50);
  };

  Quiz.prototype.focusHeading = function () {
    var active = this.root.querySelector('[data-tbq-step]:not([hidden]) [data-tbq-focus]');
    if (active) active.focus({ preventScroll: true });
  };

  Quiz.prototype.progress = function () {
    var total = this.state.style === 'dreambag' ? 2 : 3;
    var steps = { style: 1, room: 2, height: total };
    this.root.querySelectorAll('[data-tbq-step]').forEach(function (el) {
      var n = steps[el.getAttribute('data-tbq-step')];
      if (!n) return;
      var count = el.querySelector('[data-tbq-count]');
      var bar = el.querySelector('[data-tbq-bar]');
      if (count) count.textContent = n + ' of ' + total;
      if (bar) bar.style.width = Math.round((n / total) * 100) + '%';
    });
  };

  Quiz.prototype.update = function (changes, event, scroll) {
    for (var k in changes) this.state[k] = changes[k];
    this.renderResult();
    if (event) this.track(event);
    if (scroll) {
      var top = this.root.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }
    this.focusHeading();
  };

  /* ---- Picking the set ---------------------------------------------------- */

  Quiz.prototype.tog = function () { return this.state.style === 'dreambag' ? '' : ROOMS[this.state.room].tog; };
  Quiz.prototype.sackSize = function () { return this.state.sackSize || HEIGHTS[this.state.height].sack[0]; };
  Quiz.prototype.pjSize = function () { return HEIGHTS[this.state.height].pj; };
  Quiz.prototype.sackVariant = function (p) { return availVariant(p, p.style === 'dreambag' ? '' : this.sackSize()); };
  Quiz.prototype.pjVariant = function (p) { var size = this.pjSize(); return size ? availVariant(p, size) : null; };

  /* Sleep sacks in the chosen style and warmth, in stock in the size, in the collection's order. */
  Quiz.prototype.candidates = function () {
    var self = this, tog = this.tog();
    return this.data.sacks.filter(function (p) {
      return p.style === self.state.style && (!tog || p.tog === tog) && self.sackVariant(p);
    });
  };

  Quiz.prototype.matchPj = function (sack) {
    var self = this, print = sack.print.toLowerCase();
    return find(this.data.pajamas, function (pj) { return pj.print.toLowerCase() === print && self.pjVariant(pj); });
  };

  /* Their pick, then the same print, then the sleep sack's complementary products, then the first in stock. */
  Quiz.prototype.pickPj = function (hero) {
    var self = this, st = this.state;
    if (!this.pjSize()) return null;
    if (st.pjUser) {
      var chosen = byId(this.data.pajamas, st.pjId);
      if (chosen && this.pjVariant(chosen)) return chosen;
    }
    var same = this.matchPj(hero);
    if (same) return same;
    var recs = this.recs[hero.id];
    if (recs) {
      for (var i = 0; i < recs.length; i++) {
        var pj = byId(this.data.pajamas, recs[i]);
        if (pj && this.pjVariant(pj)) return pj;
      }
    } else if (recs === undefined) {
      this.loadRecs(hero);
    }
    return find(this.data.pajamas, function (p) { return self.pjVariant(p); });
  };

  Quiz.prototype.loadRecs = function (hero) {
    var self = this;
    this.recs[hero.id] = null;
    fetch(baseUrl(this.data.root) + 'recommendations/products.json?product_id=' + hero.id + '&intent=complementary&limit=10')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        self.recs[hero.id] = (d.products || []).map(function (p) { return p.id; });
        if (self.state.height && self.state.heroId === hero.id && !self.state.pjUser && !self.matchPj(hero)) self.renderResult();
      })
      .catch(function () { self.recs[hero.id] = []; });
  };

  /* ---- Rendering the result ----------------------------------------------- */

  Quiz.prototype.renderResult = function () {
    var self = this, st = this.state, d = this.data;
    var main = this.root.querySelector('[data-tbq-result]');
    var others = this.root.querySelector('[data-tbq-others]');
    var browse = this.root.querySelector('[data-tbq-browse]');
    var style = STYLES[st.style], h = HEIGHTS[st.height], tog = this.tog(), size = this.sackSize();
    var list = this.candidates();

    var picks = [style.name];
    if (st.style !== 'dreambag') picks.push(ROOMS[st.room].label);
    picks.push(h.label);
    var html = '<div class="tbq-picks"><span>' + esc(picks.join(' · ')) + '</span><button type="button" class="tbq-textbtn" data-tbq-restart>Edit</button></div>';

    var sizeRow = '';
    if (st.style !== 'dreambag' && h.sack.length > 1) {
      var asc = h.sack.slice().sort(function (a, b) { return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); });
      sizeRow = '<div class="tbq-sizes"><p class="tbq-small">At ' + esc(h.label) + ', either size fits. We\'d size up for room to grow.</p><div class="tbq-sizes__btns" role="group" aria-label="Sleep sack size">' +
        asc.map(function (s) {
          return '<button type="button" class="tbq-size" data-tbq-size="' + s + '" aria-pressed="' + (s === size) + '">' + esc(sizeLabel(s)) + (s === h.sack[0] ? ' · suggested' : '') + '</button>';
        }).join('') + '</div></div>';
    }

    var browseLinks = [];
    if (st.style === 'dreambag') {
      if (d.styleUrls.dreambag) browseLinks.push(['All Dreambags', d.styleUrls.dreambag]);
    } else {
      var sizeUrl = d.links[st.style + '-' + size] || d.styleUrls[st.style];
      if (sizeUrl) browseLinks.push(['All ' + style.plural + ' in ' + sizeLabel(size), sizeUrl]);
    }
    if (d.pajamaUrl) browseLinks.push(['All pajamas', d.pajamaUrl]);
    browse.innerHTML = '<h2 class="tbq-h3">Keep browsing</h2>' +
      browseLinks.map(function (l) { return '<a class="tbq-browse__link" href="' + esc(l[1]) + '">' + esc(l[0]) + ICON_RIGHT + '</a>'; }).join('') +
      '<button type="button" class="tbq-browse__link" data-tbq-restart>Retake the quiz' + ICON_RIGHT + '</button>';

    if (st.style === 'dreambag' && (st.height === 'h4' || st.height === 'h5')) {
      this.current = null;
      main.innerHTML = html + '<h2 class="tbq-h2" tabindex="-1" data-tbq-focus>Dreambags fit up to 35 in.</h2>' +
        '<p class="tbq-sub">Taller toddlers do best in a Dreamsuit: legs to walk, sized by height up to 4T.</p>' +
        '<div class="tbq-buy"><button type="button" class="tbq-cta" data-tbq-to-dreamsuit>Try the Dreamsuit</button></div>';
      others.innerHTML = '';
      return;
    }

    if (!list.length) {
      this.current = null;
      main.innerHTML = html + '<h2 class="tbq-h2" tabindex="-1" data-tbq-focus>Nothing in that exact mix is in stock right now.</h2>' +
        '<p class="tbq-sub">' + (sizeRow ? 'Try the other size, or browse everything below.' : 'Browse everything below, or change an answer.') + '</p>' + sizeRow;
      others.innerHTML = '';
      return;
    }

    var hero = byId(list, st.heroId);
    if (!hero) hero = find(list, function (p) { return self.matchPj(p); }) || list[0];
    st.heroId = hero.id;
    var sv = this.sackVariant(hero);
    var pj = this.pickPj(hero);
    var pv = pj ? this.pjVariant(pj) : null;
    if (pj) st.pjId = pj.id;
    this.current = { hero: hero, sv: sv, pj: pj, pv: pv };

    var title;
    if (pj && pj.print.toLowerCase() === hero.print.toLowerCase()) title = hl(hero.print) + ', head to toe';
    else if (pj) title = hl(hero.print) + ' ' + esc(style.name) + ' + ' + hl(pj.print) + ' pajamas';
    else title = hl(hero.print) + ' ' + esc(style.name);

    var chips = '<span class="tbq-chip">' + esc(style.chip) + '</span>';
    if (tog && TOGS[tog]) chips += '<span class="tbq-chip ' + TOGS[tog].cls + '">' + esc(tog + ' TOG · ' + TOGS[tog].note) + '</span>';
    if (st.style !== 'dreambag') chips += '<span class="tbq-chip">' + esc((h.sack.length > 1 && size === h.sack[0] ? 'Sized up to ' : 'Size ') + sizeLabel(size, sv.label)) + '</span>';

    var pjChoices = pj ? this.data.pajamas.filter(function (p) { return self.pjVariant(p); }) : [];
    var tile = function (p, v, isPj) {
      var url = withVariant(p.url, v.id);
      var meta = '';
      if (!isPj && p.tog && TOGS[p.tog]) meta += '<span class="tbq-tog ' + TOGS[p.tog].cls + '">' + esc(p.tog) + ' TOG</span>';
      meta += '<span>' + esc(p.style === 'dreambag' ? 'One size' : sizeLabel(v.size, v.label)) + '</span>';
      var change = isPj && pjChoices.length > 1 ? '<button type="button" class="tbq-textbtn" data-tbq-pj-toggle aria-expanded="' + st.pjOpen + '">Change print</button>' : '';
      return '<div class="tbq-tile">' +
        '<a class="tbq-tile__media" href="' + esc(url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="600" height="600" loading="lazy">' : '') + '</a>' +
        '<div class="tbq-tile__badge" data-tbq-badge-slot="' + p.id + '"></div>' +
        '<a class="tbq-tile__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
        '<p class="tbq-tile__meta">' + meta + '</p>' +
        '<p class="tbq-tile__price"><span>' + esc(money(v.price, d.moneyFormat)) + '</span>' + change + '</p>' +
        '</div>';
    };

    /* Three blocks: one column on mobile (head, tiles, buy); on desktop the tiles sit left of head + buy */
    html += '<div class="tbq-res"><div class="tbq-res__head">' +
      '<p class="tbq-eyebrow">Their sleep set</p>' +
      '<h2 class="tbq-h1 tbq-h1--result" tabindex="-1" data-tbq-focus>' + title + '</h2>' +
      '<div class="tbq-chips">' + chips + '</div>' +
      '</div><div class="tbq-res__media">' +
      '<div class="tbq-tiles' + (pj ? '' : ' tbq-tiles--one') + '">' + tile(hero, sv, false) + (pj ? tile(pj, pv, true) : '') + '</div>';

    if (pj && st.pjOpen) {
      html += '<div class="tbq-pjpick" role="group" aria-label="Pajama prints">' + pjChoices.map(function (p) {
        return '<button type="button" class="tbq-swatch" data-tbq-pj="' + p.id + '" aria-pressed="' + (p.id === pj.id) + '">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" width="600" height="600" loading="lazy">' : '') + '<span>' + esc(p.print) + '</span></button>';
      }).join('') + '</div>';
    }
    html += '</div><div class="tbq-res__buy">' + sizeRow;
    if (!this.pjSize()) html += '<p class="tbq-small tbq-gap">Our pajamas fit up to 38 in, so this one is the sleep sack on its own.</p>';

    var total = sv.price + (pv ? pv.price : 0);
    var perks = '';
    if (pv && d.perkSet) perks += '<li>' + ICON_TRUCK + esc(d.perkSet) + '</li>';
    if (d.perkThree) perks += '<li>' + ICON_TAG + esc(d.perkThree) + '</li>';
    html += '<div class="tbq-buy">' +
      '<button type="button" class="tbq-cta" data-tbq-add="' + (pv ? 'set' : 'sack') + '">' + (pv ? 'Add the set · ' : 'Add to cart · ') + esc(money(total, d.moneyFormat)) + '</button>' +
      (perks ? '<ul class="tbq-perks">' + perks + '</ul>' : '') +
      '<div class="tbq-buy__row">' +
        (pv ? '<button type="button" class="tbq-textbtn" data-tbq-add="sack">Just the ' + esc(style.name) + '</button>' : '<span></span>') +
        (d.formId && d.offerLink ? '<a class="tbq-textbtn tbq-textbtn--strong" href="#' + esc(d.offerId) + '" data-tbq-offer-link>' + esc(d.offerLink) + ICON_DOWN + '</a>' : '') +
      '</div>' +
      '<p class="tbq-error" role="alert" data-tbq-error hidden></p>' +
      '</div></div></div>';
    main.innerHTML = html;

    var rest = list.filter(function (p) { return p.id !== hero.id; });
    rest.sort(function (a, b) { return (self.matchPj(b) ? 1 : 0) - (self.matchPj(a) ? 1 : 0); });
    var top3 = rest.slice(0, 3);
    if (top3.length) {
      var fitUrl = st.style === 'dreambag' ? d.styleUrls.dreambag : (d.links[st.style + '-' + tog.replace('.', '-') + '-tog-' + size] || d.styleUrls[st.style]);
      others.innerHTML = '<section class="tbq-others">' +
        '<h2 class="tbq-h3">Other prints you may like</h2>' +
        '<p class="tbq-small">' + (st.style === 'dreambag' ? 'Also in stock. Tap one to swap it in.' : 'Same fit, same warmth, in stock in ' + esc(sizeLabel(size)) + '. Tap one to swap it in.') + '</p>' +
        '<div class="tbq-others__grid">' + top3.map(function (p) {
          return '<button type="button" class="tbq-other" data-tbq-swap="' + p.id + '">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="" width="600" height="600" loading="lazy">' : '') +
            '<span class="tbq-other__name">' + esc(p.print) + '</span>' +
            (self.matchPj(p) ? '<span class="tbq-chip tbq-chip--sm">Matching PJs</span>' : '') +
            '</button>';
        }).join('') + '</div>' +
        (fitUrl ? '<a class="tbq-seeall" href="' + esc(fitUrl) + '">See all ' + list.length + ' that fit' + ICON_RIGHT + '</a>' : '') +
        '</section>';
    } else {
      others.innerHTML = '';
    }

    this.root.querySelectorAll('[data-tbq-badge-slot]').forEach(function (slot) {
      var tpl = self.root.querySelector('template[data-tbq-badge="' + slot.getAttribute('data-tbq-badge-slot') + '"]');
      if (tpl) slot.appendChild(tpl.content.cloneNode(true));
    });
  };

  /* ---- Cart --------------------------------------------------------------- */

  Quiz.prototype.add = function (kind, btn) {
    var self = this, c = this.current;
    if (!c || this.adding) return;
    var items = [{ id: c.sv.id, quantity: 1, properties: { _source: SOURCE } }];
    if (kind === 'set' && c.pv) items.push({ id: c.pv.id, quantity: 1, properties: { _source: SOURCE } });
    var base = baseUrl(this.data.root);
    var err = this.root.querySelector('[data-tbq-error]');
    var helper = window.Alpine && Alpine.store('xCartHelper');
    this.adding = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;

    /* Honor Eurus's cart-op mutex, same as the PDP cross-sell (see CUSTOMIZATIONS.md). */
    Promise.resolve(helper && helper.waitForCartUpdate ? helper.waitForCartUpdate() : null)
      .then(function () {
        window.updatingCart = true;
        return fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || '');
        self.track(kind === 'set' ? 'add_set' : 'add_sack');
        return fetch(base + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Sleep sack finder': 'yes' } })
        }).catch(function () {});
      })
      .then(function () {
        var mini = window.Alpine && Alpine.store('xMiniCart');
        if (mini && mini.reLoad) mini.reLoad();
        setTimeout(function () {
          var bubble = document.getElementById('cart-icon-bubble');
          if (helper && bubble) helper.currentItemCount = parseInt(bubble.innerHTML, 10) || 0;
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          if (mini && mini.openCart) mini.openCart();
        }, 250);
      })
      .catch(function (e) {
        if (err) {
          err.textContent = (e && e.message) || 'Something went wrong adding to cart. Please try again.';
          err.hidden = false;
        }
      })
      .then(function () {
        window.updatingCart = false;
        self.adding = false;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  };

  /* ---- Klaviyo, votes, tracking ------------------------------------------- */

  Quiz.prototype.setProps = function () {
    var st = this.state, c = this.current;
    return {
      'Sleep sack finder style': st.style ? STYLES[st.style].name : '',
      'Sleep sack finder TOG': st.style ? this.tog() : '',
      'Sleep sack finder height': st.height ? HEIGHTS[st.height].label : '',
      'Sleep sack finder set': c ? c.hero.title + (c.pj ? ' + ' + c.pj.title : '') : ''
    };
  };

  Quiz.prototype.identify = function (props) {
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(props);
    else (window._learnq = window._learnq || []).push(['identify', props]);
  };

  Quiz.prototype.sendVotes = function () {
    var form = this.root.querySelector('[data-tbq-vote-form]');
    var thanks = this.root.querySelector('[data-tbq-vote-thanks]');
    var idea = this.root.querySelector('[data-tbq-idea]');
    var votes = [];
    this.root.querySelectorAll('[data-tbq-vote][aria-pressed="true"]').forEach(function (b) { votes.push(b.getAttribute('data-tbq-vote')); });
    var text = idea ? idea.value.trim() : '';
    if (!votes.length && !text) return;
    this.track('make_next', votes.join(', ') + (text ? ' | ' + text : ''));
    if (this.emailed) this.identify({ 'Make next votes': votes.join(', '), 'Make next idea': text });
    if (form) form.hidden = true;
    if (thanks) { thanks.hidden = false; thanks.focus(); }
  };

  /* One row per event in the Google Sheet (tracking URL). No personal info: emails stay in Klaviyo. */
  Quiz.prototype.track = function (event, detail) {
    var url = this.data.trackUrl;
    if (!url) return;
    var st = this.state, c = this.current;
    var body = JSON.stringify({
      event: event,
      session: this.sid,
      style: st.style,
      room: st.room,
      height: st.height ? HEIGHTS[st.height].label : '',
      size: c ? c.sv.label : '',
      set: c ? c.hero.title + (c.pj ? ' + ' + c.pj.title : '') : '',
      detail: detail || '',
      page: location.pathname
    });
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, body)) return; } catch (e) {}
    try { fetch(url, { method: 'POST', mode: 'no-cors', body: body, keepalive: true }); } catch (e) {}
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-tbq]').forEach(function (el) {
      if (el.__tbq) return;
      el.__tbq = new Quiz(el);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
